import * as React from "react"

import { CommonFilters } from "@components"


export default function ManagementPricingConfigFilters() {

    return <CommonFilters
        components={{
            // The `customerID === 0` gate is one level up (the page does not render these filters
            // for anyone else), and it is cosmetic anyway: the v2 endpoints enforce it with
            // `require_admin`, because the payload carries the target customer.
            customer: true,
            // No Search button: the customer is the only input, so selecting it loads everything
            // (`usePricingConfigSetup`). A submit that adds nothing is a submit that invites doubt
            // about whether the screen is up to date.
            actions: false
        }}
        compProps={{
            // Single, not multiple: this form configures one customer at a time.
            customer: { grid: { md: 4, xs: 12 }, multiple: false, placeholder: 'Select a customer...' }
        }}
    />
}
